// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --blue: #0562fb;
  --light-blue: #5271ff;
  --dark-blue: #353a50;
  --dark-background: #2b2f42;
  --main-background: #f7f7ff;
  /* --main-background: #F5F5F5; */
  --surface-g0: #f5f5f5;
  --surface-g1: #e6e6e6;
  --surface-g2: #bdbdbd;
  --surface-g3: #949494;
  --surface-g5: #333333;
  --surface-g4: #6b6b6b;
  --surface-white: #ffffff;
  --surface-black: #0B0B0B;
  --blue-b0: #0860e6;
  --blue-b1: #2a71ff;
  --blue-b2: #67B5DC;
  --blue-b4: #D9F2FF;
  --blue-org: #007AFF;
  --red-solid: #E90000;
  --green-g0: #0B742C;
  --green-g2: #87C55D;
  --green-g4: #E8FFD8;
  --sand-solid: #EBA85A;
  --grey-200: #DADDE3;
}

* {
  font-family: "Outfit", "Inter", sans-serif;
}

body {
  background-color: #f5f5f5 !important;
  transition: background-color 0.3s ease;
}

body.dark {
  background-color: #0f172a !important;
}

.MuiDataGrid-columnHeaders {
  border-left: none;
  border-right: none;
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  min-height: 45px !important;
  max-height: 48px !important;
}
.MuiDataGrid-columnHeaderTitle {
  color: black !important;
  font-weight: 700;
}
.MuiDataGrid-cellContent {
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./client/src/index.css"],"names":[],"mappings":"AACA;EACE,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;EAC1B,0BAA0B;EAC1B,gCAAgC;EAChC,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;EACxB,wBAAwB;EACxB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;EACtC,uCAAuC;EACvC,2BAA2B;EAC3B,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap\");\n:root {\n  --blue: #0562fb;\n  --light-blue: #5271ff;\n  --dark-blue: #353a50;\n  --dark-background: #2b2f42;\n  --main-background: #f7f7ff;\n  /* --main-background: #F5F5F5; */\n  --surface-g0: #f5f5f5;\n  --surface-g1: #e6e6e6;\n  --surface-g2: #bdbdbd;\n  --surface-g3: #949494;\n  --surface-g5: #333333;\n  --surface-g4: #6b6b6b;\n  --surface-white: #ffffff;\n  --surface-black: #0B0B0B;\n  --blue-b0: #0860e6;\n  --blue-b1: #2a71ff;\n  --blue-b2: #67B5DC;\n  --blue-b4: #D9F2FF;\n  --blue-org: #007AFF;\n  --red-solid: #E90000;\n  --green-g0: #0B742C;\n  --green-g2: #87C55D;\n  --green-g4: #E8FFD8;\n  --sand-solid: #EBA85A;\n  --grey-200: #DADDE3;\n}\n\n* {\n  font-family: \"Outfit\", \"Inter\", sans-serif;\n}\n\nbody {\n  background-color: #f5f5f5 !important;\n  transition: background-color 0.3s ease;\n}\n\nbody.dark {\n  background-color: #0f172a !important;\n}\n\n.MuiDataGrid-columnHeaders {\n  border-left: none;\n  border-right: none;\n  border-top-left-radius: 0px !important;\n  border-top-right-radius: 0px !important;\n  min-height: 45px !important;\n  max-height: 48px !important;\n}\n.MuiDataGrid-columnHeaderTitle {\n  color: black !important;\n  font-weight: 700;\n}\n.MuiDataGrid-cellContent {\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
